<template>
  <b-modal id="updateAgreementModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.excmagreement.updateAgreementHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <EXCMAgreementUpdate></EXCMAgreementUpdate>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="float-right">
          <b-button v-if="$store.state.userdata.update.updated" class="btn btn-secondary" @click="closeModal()">{{ $t('buttons.close') }}</b-button>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import EXCMAgreementUpdate from '../Update.vue'
export default {
  name: 'UpdateAgreementModal',
  components: {
    EXCMAgreementUpdate
  },
  computed: {
    show () {
      return this.$store.state.modals.excmagreement.update.show
    },
    agreement () {
      return this.$store.state.modals.excmagreement.update.agreement
    },
    close () {
      return this.$store.state.modals.excmagreement.update.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'agreement': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      action: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.agreement) {
        this.$store.state.modals.excmagreement.update.show = 0
        this.$store.state.modals.excmagreement.update.agreement = null
        this.$bvModal.show('updateAgreementModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.excmagreement.update.close = 0
        this.$bvModal.hide('updateAgreementModal')
      }
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
